'use client'

type VideoPreviewProps = {
  src: string
  title?: string
  protectedPreview?: boolean
  controls?: boolean
  className?: string
}

export function VideoPreview({
  src,
  title = 'Prévia do vídeo',
  protectedPreview = true,
  controls = false,
  className = '',
}: VideoPreviewProps) {
  return (
    <span className={`videoPreviewFrame ${controls ? 'hasControls' : ''} ${className}`}>
      <video
        src={src}
        aria-label={title}
        controls={controls}
        controlsList="nodownload noremoteplayback"
        disablePictureInPicture={protectedPreview}
        muted={!controls}
        playsInline
        preload="metadata"
      />
      {protectedPreview && (
        <span className="videoWatermarkGrid" aria-hidden="true">
          {Array.from({ length: 20 }, (_, index) => (
            <b key={index}>OUTRO ÂNGULO · AMOSTRA</b>
          ))}
        </span>
      )}
    </span>
  )
}
